import messageBus from './bus.js'
import {getBrowserCode} from "../browser-code";

export default {
    openState: false,
    // 未发送消息
    socketMessageQueue: [],
    // 心跳连接定时器
    heartTimer: null,
    // 外部this
    _vm: null,
    // socket
    connection: null,
    // 启动连接
    connect(vm) {
        const that = this
        that._vm = vm
        // 连接
        that.connection = new WebSocket(process.env.VUE_APP_SOCKET)

        // 获取消息
        that.connection.onmessage = function (res) {
            messageBus.$emit('onMessage', JSON.parse(res.data))
        }
        // 打开连接
        that.connection.onopen = function (res) {
            that.openState = true
            if (that.socketMessageQueue.length > 0) {
                for (let i = 0; i < that.socketMessageQueue.length; i++) {
                    that.send(that.socketMessageQueue[i])
                }
            }
            that.socketMessageQueue = []

            // 心跳连接
            clearInterval(that.heartTimer)
            that.heartTimer = setInterval(() => {
                that.send({
                    type: 'keep'
                })
            }, 15000)

            // 绑定浏览器
            if (getBrowserCode()) {
                that.send({
                    type: 'bindBrowser',
                    browserCode: getBrowserCode()
                })
            }
        }

        // 失败重连
        that.connection.onerror = function (res) {
            let tempTimer = setTimeout(() => {
                that.connect(vm)
                clearTimeout(tempTimer)
            }, 3000)
            clearInterval(that.heartTimer)
        }

        // 关闭重连
        that.connection.onclose = function (res) {
            let tempTimer = setTimeout(() => {
                that.connect(vm)
                clearTimeout(tempTimer)
            }, 3000)
            clearInterval(that.heartTimer)
        }
    },
    /**
     * 发送消息
     * @param {Object} message
     */
    send(message) {
        const that = this
        if (that.openState) {
            that.connection.send(JSON.stringify(message))
        } else {
            that.socketMessageQueue.push(message)
        }
    }
}